import { getDateTime } from "lib/dates";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
	date: string;
};

export default function StartDate({ date }: Props) {
	const { t, i18n } = useTranslation();
	return (
		<>
			{/* Returns date with time if date is available */}
			{date ? getDateTime(date, i18n.language, t) : t("main.text.notSet")}
		</>
	);
}
